import { createAsyncActionTypes } from '../../util/createLifeomicActionTypes';

export default createAsyncActionTypes([
  'GET_USER_INVITATIONS',
  'SEND_GROUP_INVITATION',
  'SEND_LX_INVITATION',
  'SEND_OPEN_LINK_INVITATION',
  'SEND_GROUP_INVITATION_ERROR',
  'RESPOND_TO_INVITATION',
  'GET_INVITE_BY_ID',
]);
